import React from "react"
import { LOST, FOUND } from "../../../jacdac-ts/src/jdom/constants"
import { JDDevice } from "../../../jacdac-ts/src/jdom/device"
import useChange from "../../jacdac/useChange"
import useEventRaised from "../../jacdac/useEventRaised"
import Alert from "../ui/Alert"

export function DeviceLostAlert(props: { device: JDDevice }) {
    const { device } = props
    const lost = useEventRaised([LOST, FOUND], device, dev => !!dev?.lost)
    const flashing = useChange(
        device,
        _ => _?.bootloader || !!_?.firmwareUpdater
    )
    if (!lost || flashing) return null
    return <Alert severity="info">Device lost...</Alert>
}
